export default "https://cdn-static.gokick.com/assets/eeaee1442152ca0221916151b947444cbee5198d/images/two-pack.1e6632cffb735562eaf44e7ebc36435e.png";